import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MultiStepSurvey from './MultiStepSurvey';

const App = (props) => (
  <div>
    <MultiStepSurvey/>
  </div>
)

export default App;
